// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__aBFBx","bigColWidth":"Table_bigColWidth__1qii-","biggerColWidth":"Table_biggerColWidth__1yGvN","row":"Table_row__2EP52","col":"Table_col__2V0hb"};